import serviceUserRequest from '@ertelecom/ui-react/components/requests/serviceUserRequest';
// @ts-ignore
import { dataLayerPush } from '@ertelecom/ui-react/components/helpers';
import { dataLayerForCPA } from '~/src/helpers/eventsForDataLayer';
import cookie from 'react-cookies';
import { getClientId } from '~/src/helpers/clientInfo';

export enum EProductsId {
    internet = 5,
    tv = 53,
    telephony = 31,
    tvAndInternet = 0,
    content = 67,
}

export interface IBaseRequestByConnectionParam {
    fio: string,
    phone: string,
    domain: string,
    product_id: EProductsId | EProductsId[],
    ga_cid: number,
    form_type?: string,
    plan?: number,
    leasing_duration?: number,
    cost_type?: number,
    petition?: string,
    check_call_type?: string,
}

export interface IRequestByConnectionParam  extends IBaseRequestByConnectionParam {
    router?: number | number[],
    internet_equipment_id?: number | number[],
    tv_equipment_id?: number | number[],
}

export interface IRequestByConnectionResult {
    billing_code: number,
    message: string,
    request_id: number,
}

/**
 * * GET-запрос заявка на подключение /user/request-by-connection.
 * TODO: в api-request для данного URI реализован метод GET и Post с одинаковой функциональностью, определиться с ипользованием метода, удалить дубль.
 * @param {string} cityDomain поддомен хоста b2c
 * @param {Object} params - параметры запроса, описание: (https://master.api-request.services.t2.ertelecom.ru/docs)
 * @param {string} params.fio - The name of the employee.
 * @param {string} params.phone - The employee's department.
 * @param {string} params.product_id - (0-прочее, 5-интернет, 53-Дом.ру Tv, 67-продажа контента).
 * @return {object} data
 */
export const sendRequestByConnection = async(
    cityDomain: string,
    data: IRequestByConnectionParam | FormData,
    billingHost?: string
): Promise<IRequestByConnectionResult> => {

    const isFormData = data instanceof FormData;

    if (window) {
        const { pathname } = window.location;
        if (isFormData) {
            (data as FormData).set('check_call_type', pathname);
        } else {
            (data as IRequestByConnectionParam).check_call_type = pathname;
        }
    }

    const resp = await serviceUserRequest(cityDomain, billingHost).post(
        '/user/request-by-connection',
        data,
        {
            headers: {
                'Content-Type': isFormData ? 'multipart/form-data' : 'application/json; charset=utf-8',
            },
        },
    );

    const respData = resp.data;

    return respData;
};

export type RequestByConnectionInternet = Omit<
    IRequestByConnectionParam,
    'petition'|'ga_cid'|'product_id'|'internet_equipment_id'|'tv_equipment_id'
>;

export const sendRequestByConnectionInternet = async(
    cityDomain: string,
    data: RequestByConnectionInternet | FormData,
    billingHost: string | undefined = undefined
): Promise<IRequestByConnectionResult> => {
    const clientId = cookie.load('_ga_cid');

    const params = {
        petition: 'create_request',
        ga_cid: clientId ? clientId : getClientId(),
        product_id: EProductsId.internet,
        ...data,
    };

    return sendRequestByConnection(cityDomain, params, billingHost);
};

export type RequestByConnectionTv = Omit<
    IRequestByConnectionParam,
    'petition'|'ga_cid'|'product_id'|'internet_equipment_id'|'router'
>;

export const sendRequestByConnectionTv = async(
    cityDomain: string,
    data: RequestByConnectionTv | FormData,
    billingHost: string | undefined = undefined
): Promise<IRequestByConnectionResult> => {
    const clientId = cookie.load('_ga_cid');
    const params = {
        petition: 'create_request',
        ga_cid: clientId ? clientId : getClientId(),
        product_id: EProductsId.tv,
        ...data,
    };

    return sendRequestByConnection(cityDomain, params, billingHost);
};

export interface IRespData {
    message: string,
    billing_code: number,
    request_id?: number,
}

export enum ERequestStatus {
    success = 'success',
    error = 'error',
}

export interface IParseData {
    message: string,
    ok: boolean,
    status: ERequestStatus,
}

/**
 * * Парсит ответ на запрос /user/request-by-connection, и отправляет аналитику в GTA
 */
export const parseRequestByConnection = (respData: IRespData): IParseData => {
    let ok = false;
    let status = ERequestStatus.error;

    const billingCode = Number(respData.billing_code);
    let action = 'undefined';

    if (billingCode === 0) {
        action = 'yes';
        ok = true;
        status = ERequestStatus.success;
    }

    if (billingCode === 6) {
        ok = true;
        status = ERequestStatus.success;
    }

    const errorCode = [15, 24, 101, 100];
    if (errorCode.includes(billingCode)) {
        action = 'no';
    }

    dataLayerPush(
        {
            event: 'UAevent',
            category: 'application_form',
            action,
            label: `${billingCode ?? ''}`
        }
    );

    dataLayerForCPA(respData);

    return {
        message: respData.message,
        ok,
        status,
    };
};
